module.exports = __webpack_public_path__ + "static/media/38.cb63948d.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/eyes/38.png
// module id = 542
// module chunks = 0